<template>
  <div @click="closeModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
    <div @click.stop  class="relative bg-white rounded-lg shadow-lg w-full max-w-lg mx-4">
      <!-- Modal header -->
      <div class="flex items-center justify-between p-4 border-b">
        <h3 class="text-xl font-semibold text-gray-900">
          Cancel Session
        </h3>
        <button @click="closeModal" class="text-gray-400 hover:text-gray-500">
          <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <!-- Modal body -->
      <div class="p-4 pt-4">
        <form @submit.prevent="submitForm">
          <p class="font-medium">Are you sure you want to cancel this session?</p>
          <p class="mt-2 text-sm">There are no registered students so you can do this safely.</p>
          <div class="flex justify-end space-x-3 mt-4">
            <button type="button"
                    @click="closeModal"
                    class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md">
              Go back
            </button>
            <button type="submit"
                    class="g--button g--button--cancel">
              Cancel Session
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import moment from 'moment';

import { ref, onMounted } from 'vue';

const formData = ref({
});

const props = defineProps({
  classItem: {
    type: Object,
    required: true
  },
  sessionId: {
    type: Number,
    required: false
  },
  startTime: {
    type: String,
    required: false
  },
  duration: {
    type: Number,
    required: false
  }
});
const emit = defineEmits(['session-deleted']);

const closeModal = () => {
  emit('session-close');
};

onMounted(() => {

});

const submitForm = () => {
  saveSession();
};

const saveSession = async (sessionData) => {
  // Save the class data

  try {
    let data = {
      sectionId: 2,
      enabled: false
    };
    if (props.sessionId) {
      data.entryId = props.sessionId;
    }
    data[csrfTokenName] = csrfTokenValue;

    const response = await fetch('/actions/entries/save-entry', {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to save entry');
    }

    const savedEntry = await response.json();

    // Optional: Emit the saved entry data
    emit('session-deleted', sessionData);
    closeModal();

  } catch (error) {
    console.error('Error deleting entry:', error);
  }
};


</script>
